import type { ProductCategory, ProductKind } from '@iheartjane/types';
import { sentenceCase } from '@iheartjane/utils';

import type { CustomLanguage } from '@jane/bloom/loaders/rootLoader';
import { formatLabel } from '@jane/bloom/utils/strings/formatLabel';

interface GetProductCategoryLabelArgs {
  category?: ProductCategory | null;
  customLanguage: Pick<CustomLanguage, 'lineageLabels' | 'productTypeLabels'>;
  kind: ProductKind;
}

export const getProductCategoryLabel = ({
  category,
  customLanguage,
  kind,
}: GetProductCategoryLabelArgs) => {
  const lineageLabel = category
    ? customLanguage.lineageLabels?.[category] || category
    : '';
  const kindLabel = customLanguage.productTypeLabels?.[kind] || kind;

  return lineageLabel
    ? `${formatLabel(lineageLabel, { uppercaseAcronyms: ['CBD'] })} ${kindLabel}`
    : sentenceCase(kindLabel);
};
